import { $$ } from 'utils/dom';
import LoadMore from 'modules/load-more';

const newsTeasers = $$('.news-teaser[data-ajax]');
newsTeasers.length &&
  newsTeasers.forEach(teaser => {
    teaser &&
      new LoadMore({
        container: teaser,
      }).init();
  });
